const swiper3 = new MinimogLibs.Swiper(".slider-t4e", {
  direction: "horizontal",
  spaceBetween: 10,
  loop: true,
  slidesPerView: 4,
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
    breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 20
    },
         768: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});
